// GoldSrc / Counter-Strike 1.6 movement constants (units are inches/second).
// Sources: jwchong.com Half-Life Physics Reference + CS server cvar defaults.

export const GRAVITY = 800
export const MAX_SPEED = 221 // AK-47 caps the player at 221 u/s
export const ACCELERATE = 5 // sv_accelerate
export const AIR_ACCELERATE = 10 // sv_airaccelerate
export const FRICTION = 4 // sv_friction
export const STOP_SPEED = 75 // sv_stopspeed
export const AIR_WISH_CAP = 30 // air-accel wishspeed clamp (enables strafe/bhop)
export const JUMP_SPEED = 268 // sqrt(2 * 800 * 45) ≈ a 45-unit jump

export const WALK_FACTOR = 0.52 // +speed (slow walk)
export const DUCK_FACTOR = 0.34 // crouch speed multiplier

export const STAND_EYE = 60 // eye height above feet, standing
export const DUCK_EYE = 34 // eye height above feet, crouched
export const STAND_HEIGHT = 72 // hull height, standing
export const DUCK_HEIGHT = 36 // hull height, crouched
export const RADIUS = 16 // hull half-width
export const STEP_HEIGHT = 18 // max stair step-up
export const DUCK_TIME = 0.18 // seconds to fully crouch/stand
export const TP_DIST = 150 // third-person camera distance behind the player
